import React from 'react';

import { ProductTilePlaceholder, Row } from '@notino/react-styleguide-v20';

import { ReactFCV } from '@types';

import { StyledProductSkeletonWrapper } from './styled';

export const UpsellingProductRowSkeleton: ReactFCV = () => (
  <Row>
    <StyledProductSkeletonWrapper xs={6} md={3}>
      <ProductTilePlaceholder hasButton={true} rows={2} />
    </StyledProductSkeletonWrapper>
    <StyledProductSkeletonWrapper xs={6} md={3}>
      <ProductTilePlaceholder hasButton={true} rows={2} />
    </StyledProductSkeletonWrapper>
    <StyledProductSkeletonWrapper xs={6} md={3}>
      <ProductTilePlaceholder hasButton={true} rows={2} />
    </StyledProductSkeletonWrapper>
    <StyledProductSkeletonWrapper xs={6} md={3}>
      <ProductTilePlaceholder hasButton={true} rows={2} />
    </StyledProductSkeletonWrapper>
  </Row>
);
